import Vue from 'vue'

export default {
  listarAutor: () => {
        return Vue.prototype.$http("/graphql", {
            data:{
              query: `{
                listarAutor{
                  id
                  nome
                  foto
                  email
                  contato
                }
              }`
            }
        })
    },
    listarAutorByNome: (nome) => {
      return Vue.prototype.$http("/graphql", {
          data:{
            query: `{
              listarAutor(nome: "${nome}"){
                id
                nome
                foto
                email
                contato
              }
            }`
          }
      })
  },
    criarAutor: (autorInput) => {
      return Vue.prototype.$http("/graphql", {
        data:{
          query: `mutation{
            criarAutor(data:{
              nome: "${autorInput.nome}"
              email: "${autorInput.email}"
              contato: "${autorInput.contato}"
              foto: "${autorInput.foto}"
            })
            {
              id
              nome
              foto
              email
              contato
            }
          }`
        }
      })
    },
    atualizarAutor: (autorInput) => {
      return Vue.prototype.$http("/graphql", {
        data:{
          query: `mutation{
            atualizarAutor(id: ${autorInput.id}, data:{
              nome: "${autorInput.nome}"
              email: "${autorInput.email}"
              contato: "${autorInput.contato}"
              foto: "${autorInput.foto}"
            })
            {
              id
              nome
              foto
              email
              contato
            }
          }`
        }
      })
    },
    deletarAutor: (autorId) => {
      return Vue.prototype.$http("/graphql", {
        data:{
          query: `mutation{
            deletarAutor(id: ${autorId})
          }`
        }
      })
    },
}
